export default function InvisibleIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z"
        stroke="#DDCEEC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M17.8198 5.77047C16.0698 4.45047 14.0698 3.73047 11.9998 3.73047C8.46984 3.73047 5.17984 5.81047 2.88984 9.41047C1.98984 10.8205 1.98984 13.1905 2.88984 14.6005C3.67984 15.8405 4.59984 16.9105 5.59984 17.7705"
        stroke="#DDCEEC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M8.41992 19.5297C9.55992 20.0097 10.7699 20.2697 11.9999 20.2697C15.5299 20.2697 18.8199 18.1897 21.1099 14.5897C22.0099 13.1797 22.0099 10.8097 21.1099 9.39969C20.7799 8.87969 20.4199 8.38969 20.0499 7.92969"
        stroke="#DDCEEC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.5099 12.6992C15.2499 14.1092 14.0999 15.2592 12.6899 15.5192" stroke="#DDCEEC" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.47 14.5293L2 21.9993" stroke="#DDCEEC" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M21.9998 2L14.5298 9.47" stroke="#DDCEEC" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>

  )
}
